__turbopack_context__.v({
  "bg": "Hero-module__EuRKEq__bg",
  "img": "Hero-module__EuRKEq__img",
  "slideshow-bg": "Hero-module__EuRKEq__slideshow-bg",
  "slideshow-bg__img": "Hero-module__EuRKEq__slideshow-bg__img",
  "swiper": "Hero-module__EuRKEq__swiper",
  "wrapper": "Hero-module__EuRKEq__wrapper",
});
